// ⚠️ FILE SINH TỰ ĐỘNG bởi scripts/gen-i18n-shims.mjs — đừng sửa tay.
// Cụm: common
import { messages } from '../../../locales/vi/common.mjs';
import { registerCluster } from '../runtime.js';

const loaders = {
  en: () => import('../../../locales/en/common.mjs'),
  fr: () => import('../../../locales/fr/common.mjs'),
  es: () => import('../../../locales/es/common.mjs'),
};

registerCluster('common', messages, (locale) => loaders[locale]());
